
import React, { useCallback } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CountrySelect from "../extra/CountrySelect";
import { localCountryCode } from "../../libs/Libs";

export default function TimeCamForm({ title, companies = [], projects = [], users = [],
    defaultValues = {}, onSubmit = (data) => { },
    onChange = (column, data) => { },
    back = () => { }
}) {
    //const lang = navigator.language; // e.g., "en-US"
    let country = defaultValues?.country ? defaultValues.country : localCountryCode()
    const [open, setOpen] = React.useState(false)
    const { errors, handleSubmit, control, watch, setValue, register, clearErrors } = useForm({ defaultValues: defaultValues, mode: "all" })
    React.useEffect(() => {
        onChange("company", watch("company"))
    }, [watch("company")])

    const booleanFields = [
        // { name: "allow_recording", label: "Allow Recording", watch: watch("allow_recording") },
        { name: "active", label: "Active", watch: watch("active") },
    ];
    // React.useEffect(() => {
    //     register("country", { required: "Country is required" });
    // }, [register,watch("country")]);
    return (
        <>
            <Box sx={{ p: 2 }}>
                <form onSubmit={handleSubmit((data) => {
                    console.log("data submit", data)
                    onSubmit(data)
                })}>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="camera_name" label="Name" control={control} rules={{
                                required: true, maxLength: 500,
                                pattern: {
                                    value: /^[A-Za-z0-9\s\-_.]+$/,
                                    message: "Invalid camera name. Allowed: letters, numbers, spaces, - _ .",
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Camera Name" />
                            </RFG>
                            <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
                                <select>
                                    <option value="">Select Company</option>
                                    {companies.map((company) => <option value={company.id}>{company.company_name}</option>)}
                                </select>
                            </RFG>
                            <RFG name="project" label="Project Name" control={control} rules={{ required: true }} className="mb-2">
                                <select>
                                    <option value="">Select Project</option>
                                    {projects.map((project) => <option value={project.id}>{project.project_name}</option>)}
                                </select>
                            </RFG>

                            <RFG name="camera_model" label="Camera Model" control={control} rules={{
                                required: true,
                                pattern: {
                                    value: /^[A-Za-z0-9._\-\s]+$/,
                                    message: "Invalid camera model. Allowed: letters, numbers, spaces, - _ .",
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Camera model for reference" />
                            </RFG>

                            <RFG name="duration" label="Duration" control={control} rules={{
                                required: true,
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Duration must be in digits",
                                },
                                maxLength: {
                                    value: 5,
                                    message: `Cannot exceed 5 digits`,
                                }
                            }}
                            >
                                <input autoComplete="false" placeholder="Duration" />
                            </RFG>
                            <RFG name="ordering" label="Ordering" control={control} rules={{
                                required: true,

                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Ordering must be in digits",
                                },
                                maxLength: {
                                    value: 9,
                                    message: `Cannot exceed 9 digits`
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Ordering" />
                            </RFG>
                            {/* <RFG name="image" label="Image" control={control} className="mb-2">
                                <input autoComplete="false" type="file" />
                            </RFG> */}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="scroll_text" label="Scroll text" control={control} rules={{
                                maxLength: 500,
                                pattern: {
                                    value: /^[A-Za-z0-9.',"_\-\s]*$/,
                                    message: "Allowed: letters, numbers, spaces, -' _ .",
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Scroll text" />
                            </RFG>
                            <RFG name="coordinates" label="Coordinates" control={control} rules={{
                                required: true, maxLength: 500,
                                pattern: {
                                    value: /^-?(?:[0-8]?\d(?:\.\d{1,35})?|90(?:\.0{1,35})?)\s*,\s*-?(?:180(?:\.0{1,35})?|(?:1[0-7]\d|\d{1,2})(?:\.\d{1,35})?)$/,
                                    message: "Invalid coordinates. Use format: latitude,longitude (e.g., -33.86880000,151.20930000)"
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="e.g. 33.8688000,151.2093000" />
                            </RFG>

                            <RFG name="image_upload_intervals" label="Image upload interval" control={control} rules={{
                                required: true, maxLength: 3,
                                pattern: {
                                    value: /^[0-9]{1,3}$/,
                                    message: "Intervals must be in digits"
                                },
                                maxLength: {
                                    value: 3,
                                    message: `Cannot exceed 3 digits`

                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Image capture time interval" />
                            </RFG>
                            {/* <RFG name="auto_timelapse_schedule_in_days" label="Auto Timelapse Schedule in days" control={control} rules={{ required: true, maxLength: 3 ,
                                 pattern: {
                                    value: /^[0-9]{1,3}$/,
                                    message: "Days must be in digits"},
                                    maxLength: {
                                        value: 3,
                                        message: `Cannot exceed 3 digits`
                                       
                                    } 
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Auto Timelapse Schedule in days"/>
                            </RFG> */}
                            <RFG name="auto_timelapse_schedule_in_days" label="Auto Timelapse Schedule in days" control={control} rules={{ required: true }} className="mb-2">
                                <select>
                                    <option value="">Select Days</option>
                                    <option value="1">Past Day</option>
                                    <option value="7">Past 7 Days</option>
                                    <option value="30">Past 30 Days</option>

                                </select>
                            </RFG>
                            <RFG name="image_retention" label="Image Retention in no. of days" control={control} rules={{
                                required: true, maxLength: 3,
                                pattern: {
                                    value: /^[0-9]{1,3}$/,
                                    message: "Days must be in digits",
                                },
                                maxLength: {
                                    value: 3,
                                    message: `Cannot exceed 3 digits`

                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Image Retention in days" />
                            </RFG>
                            <Box>
                                <RFG
                                    name="country"
                                    label="Country"
                                    control={control}
                                    rules={{ required: true, }}
                                >
                                    <CountrySelect
                                        defaultValue={defaultValues.country}
                                        labelKey="name"
                                        valueKey="code"
                                        //onValueChange={(country) => setValue("country", country.value)}
                                        onValueChange={(country) => {
                                            // Set and validate the same field name
                                            const cnty_name = country?.label || "";
                                            setValue("country_name", cnty_name);
                                            const value = country?.value || "";
                                            setValue("country", value, { shouldValidate: true });
                                            if (value) clearErrors("country");
                                            // no setError here; RHF required rule shows the message on submit
                                        }}
                                    />
                                    {/* {errors?.country?.message} */}
                                </RFG>
                            </Box>

                            <Box sx={{ my: 1, px: 1 }} display="flex" flexWrap="wrap" gap={2}>
                                {booleanFields.map(({ name, label, watch }) => (
                                    <RFG name={name} label={label} control={control} className="mb-2">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => setValue(name, e.target.checked)}
                                            checked={watch}
                                        />
                                    </RFG>
                                ))}
                            </Box>

                            <Box textAlign="right" sx={{ my: 4 }}>
                                <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                    Back
                                </Button>
                                <Button sx={{ mx: 2 }} className="btn-primary" type="submit">Save</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </>
    )
}